import { useEffect, useMemo } from "react";

const DEFAULT_TITLE = "EatLaza Main Admin";

type Filters = Record<string, string | number | undefined>;
type LabelMap = Record<string, string>;

const useDocumentTitle = (
  base?: string,
  filters?: Filters,
  map?: LabelMap
) => {
  const title = useMemo(() => {
    //  No base → default title
    if (!base) {
      return DEFAULT_TITLE;
    }

    //  No filters → simple title
    if (!filters) {
      return base;
    }

    const parts: string[] = [];

    Object.entries(filters).forEach(([key, value]) => {
      if (!value) return;

      const label = map?.[key] ?? key;
      parts.push(`${label} (${value})`);
    });

    //  Filters exist but no valid values
    if (parts.length === 0) {
      return base;
    }

    return `${base} — ${parts.join(", ")}`;
  }, [base, filters, map]);

  useEffect(() => {
    document.title = title;
  }, [title]);
};

export default useDocumentTitle;
